// extracted by mini-css-extract-plugin
export default {"root":"AdminButton_root__1c0XE"};